<!-- 音像核验 -->

<template>
  <div class="province-7">
    <div class="ttBar">
      <span>连续型电子出版物单位审核</span>
    </div>
    <div class="tabArea" v-loading="loading">
      <div class="ctrlsBar">
        <el-menu
          class="menuButton"
          mode="horizontal"
          background-color="#409EFF"
          text-color="#fff"
          active-text-color="fff"
          @select="handleSelect">
          <el-submenu :show-timeout="0" :hide-timeout="0" index="2">
            <template slot="title">批量审核</template>
            <el-menu-item index="1">通过</el-menu-item>
            <el-menu-item index="3">退回</el-menu-item>
            <el-menu-item index="21">暂缓登记</el-menu-item>
            <!-- <el-menu-item index="12">暂缓</el-menu-item> -->
            <el-menu-item index="13">注销或拟注销</el-menu-item>
            <!-- <el-menu-item index="14">建议撤销</el-menu-item> -->
          </el-submenu>
        </el-menu>
        <span class="tips">（若省局已经审核完成，请点击“上报国家新闻出版署”。）</span>

        <div class="blockRt">
          <!-- @change="tabSeek('init')"  -->
          <el-select v-model="postDat.status" size="small" placeholder="请选择">
            <el-option v-for="item in typeArr" :key="item.key" :label="item.name" :value="item.key"> </el-option>
          </el-select>

          <el-input v-model="postDat.keyword" size="small" placeholder="通过出版单位、出版物名称查询"></el-input>
          <!-- <el-button @click="tabSeek('init')" size="small">查询</el-button> -->
        </div>
      </div>
      <div>
        <el-table :data="tabDats" border style="width: 100%" @selection-change="selectionChange">
          <el-table-column :selectable="checkDfine" type="selection" width="45" align="center"></el-table-column>
          <el-table-column label="序号" width="60" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 + 15 * (postDat.no - 1) }}
            </template>
          </el-table-column>
          <el-table-column prop="organizationName" label="出版单位" align="center"> </el-table-column>
          <el-table-column prop="name" label="出版物名称" align="center"> </el-table-column>
          <el-table-column width="150" label="查阅时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row | transStr("time") }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" label="省局意见" align="center">
            <template slot-scope="scope">
              <!-- {{scope.row}} -->
              <span>{{ scope.row | transStr("sjstatus") }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" label="国家新闻出版署意见" align="center">
            <template slot-scope="scope">
              <!-- {{scope.row}} -->
              <span>{{ scope.row | transZjStr("statuszj") }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" label="状态" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row | transStr("state") }}</span>
            </template>
          </el-table-column>
          <el-table-column width="90" label="操作" align="center">
            <template slot-scope="scope">
              <!-- {{scope.row.status}} -->
              <el-button
                v-if="scope.row.status == 0 || scope.row.progress == '省局'"
                @click="goFirm(scope.row, 1)"
                type="primary"
                size="mini"
                >审核</el-button
              >
              <el-button v-else @click="goFirm(scope.row, 2)" type="primary" size="mini">查看 </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pageCage" v-if="postDat.total > 1">
          <el-pagination
            @current-change="pageSent"
            :current-page="postDat.no"
            layout="prev, pager, next"
            :page-count="postDat.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="backdiag" class="pg3_3dig" width="450px" @close="handleClose">
      <span class="tips" v-if="backtype == 3">请输入意见</span>
      <el-input v-if="backtype == 3" v-model="params.message" type="textarea" :rows="5"></el-input>

      <span class="tips" v-if="backtype == 21">请输入意见</span>
      <el-input v-if="backtype == 21" v-model="params.message" type="textarea" :rows="5"></el-input>

      <!-- <span class="tips" v-if="backtype == 12">请输入意见</span>
      <el-input v-if="backtype == 12" v-model="params.zanhuanMessage" type="textarea" :rows="5"></el-input> -->

      <span class="tips" v-if="backtype == 13">请输入意见</span>
      <el-input v-if="backtype == 13" v-model="params.zhuxiaoMessage" type="textarea" :rows="5"></el-input>

      <!-- <span class="tips" v-if="backtype == 14">请输入意见</span>
      <el-input v-if="backtype == 14" v-model="params.chexiaoMessage" type="textarea" :rows="5"></el-input> -->

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="arrExam">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  successiveWaitList,
  goProvinceExam, // zym.省局审核
} from "@/api/provinceRole/provinceRole";
export default {
  data() {
    return {
      typeArr: [
        {
          name: "全部",
          key: 99,
        },
        {
          name: "未提交",
          key: 8,
        },
        {
          name: "待审核",
          key: 0,
        },
        {
          name: "已审核",
          key: 1,
        },
      ],
      backdiag: false,
      backtype: "",
      postDat: {
        status: 99,
        keyword: "",
        isZyzj: 0,
        no: 1,
        size: 15,
      },
      tabDats: [],
      tabDatAll: [],
      pgAll: "",
      loading: false,

      examIds: [],

      params: {
        publishMaterialIds: [],
        status: 1,
        message: "",

        zanhuanMessage: "", // zym.暂缓意见
        chexiaoMessage: "", // zym.撤销意见
        zhuxiaoMessage: "", // zym.注销意见
      },
    };
  },
  filters: {
    transZjStr: function (dat, code) {
      if (code == "statuszj" && (dat.progress == "国家新闻出版署" || dat.progress == "登记")) {
        let map = {
          1: "通过",
          2: "暂缓登记",
          3: "退回",
          4: "撤销",
          5: "注销或拟注销",
          9: "整体发布",
        };
        console.log("dat.statuszj=", dat.statuszj);
        return map[dat.statuszj];
      }
    },
    transStr: function (dat, code) {
      if (code == "state") {
        let map = {
          8: "未提交",
          0: "待审核",
          1: "通过",
          3: "未提交",
          9: "已上报",

          12: "暂缓",
          13: "注销或拟注销",
          14: "建议撤销",
          21: "暂缓登记",
        };

        let setMap = {
          1: "通过",
          2: "暂缓",
          4: "撤销",
          5: "注销",
        };

        // zym.把progress 换成了 progress
        if (dat.progress == "登记") {
          // return setMap[dat.pubStatus] + "（已核验）";
          return "已发布";
        } else if (dat.progress == "国家新闻出版署") {
          return "已上报";
        } else if (dat.progress == "省局") {
          // if (dat.isBack == 2) {
          //   return map[dat.status] + "（退回）";
          // } else {
          //   return map[dat.status];
          // }
          return "";
        } else {
          if (dat.isBack == 2) {
            return "未提交（退回）";
          } else {
            return "未提交";
          }
        }
      } else if (code == "time") {
        console.log("dat.sjViewDate=", dat.sjViewDate);
        if (dat.sjViewDate && dat.sjViewDate != "Invalid date") {
          return dat.sjViewDate.substr(0, 16);
        } else {
          return "";
        }
      } else if (code == "sjstatus") {
        let map = {
          // 8: "未提交",
          // 0: "待审核",
          1: "通过",
          // 3: "未提交",
          // 9: "已上报",

          13: "注销或拟注销",
          21: "暂缓登记",
        };

        // if (dat.isBack == 2) {
        return map[dat.sjstatus];
        // } else {
        // return map[dat.status];
        // }
        // return "";
      }
    },
  },
  watch: {
    postDat: {
      deep: true, //实现深度监听
      handler(v) {
        this.params.publishMaterialIds = [];
        if (!v.goPage) {
          this.postDat.no = 1;
        }
        this.postDat.goPage = false;
        this.filterTableData();
      },
    },
  },
  methods: {
    tabSeek: function (code) {
      if (code == "init") {
        this.postDat.no = 1;
      }
      this.loading = true;
      successiveWaitList(this.postDat).then((response) => {
        this.tabDatAll = response.flxdzOrganizationMaterialList;
        // this.pgAll = response.totalPages;
        this.loading = false;

        this.filterTableData();
      });
    },
    // zym.过滤列表数据
    filterTableData: function () {
      let tabDats = this.tabDatAll;

      let qType = this.postDat.status;
      let qKeyword = this.postDat.keyword;
      // !状态
      let statusKey = { 8: "开始", 0: "省局", 1: "国家新闻出版署" };
      if (qType != "99") {
        tabDats = tabDats.filter(function (item) {
          // zym.未提交
          if (qType == 8 && (item.progress || "") == "开始") {
            return true;
          }
          // zym.待审核
          if (qType == 0 && (item.progress || "") == "省局" && item.status == "0") {
            return true;
          }
          // zym.已审核
          if (
            qType == 1 &&
            (((item.progress || "") == "省局" &&
              (item.status == "1" || item.status == "12" || item.status == "13" || item.status == "14")) ||
              (item.progress || "") == "国家新闻出版署")
          ) {
            return true;
          }
          return false;
          // if ((item.progress || '') == statusKey[qType]) {
          //   return true;
          // }
          // return false;
        });
      }
      // !关键字查询
      if (qKeyword) {
        tabDats = tabDats.filter(function (item) {
          if ((item.name || "").indexOf(qKeyword) > -1 || (item.organizationName || "").indexOf(qKeyword) > -1) {
            return true;
          }
          return false;
        });
      }

      this.tabDats = tabDats;

      // 计算分页信息
      this.calPage();
    },
    // 计算分页信息
    calPage: function (tabDatsTemp) {
      let postDat = this.postDat;
      let tabDatAll = this.tabDats;
      let dataLen = Number(tabDatAll.length);
      let size = Number(postDat.size);
      let total = Math.floor(dataLen / size);
      this.tabDats = tabDatAll.slice((postDat.no - 1) * size, postDat.no * size);

      if (dataLen % size != 0) {
        total = Math.floor(dataLen / size) + 1;
      }
      postDat["total"] = total;
      this.postDat = postDat;
    },
    pageSent: function (dat) {
      this.postDat.no = dat;
      // this.tabSeek();
      this.postDat.goPage = true;
    },
    styleTrans: function (code) {
      let styleArr = ["spanc1", "spanc2", "spanc3"];
    },
    goFirm: function (inDat, type) {
      // console.log('inDat=',JSON.stringify(inDat))
      this.$router.push({
        path: "successive_skim",
        query: {
          pressState: type,
          listId: inDat.publishMaterialId,
          pressId: inDat.organizationId,
          examId: inDat.materialExamineId,
          bookName: inDat.name,
          pressName: inDat.organizationName,
          updateViewDate: true,
        },
      });
    },

    selectionChange: function (resDat) {
      this.params.publishMaterialIds = [];
      for (let i = 0; i < resDat.length; i++) {
        this.params.publishMaterialIds.push(resDat[i].materialExamineId);
      }
    },

    handleSelect: function (dat) {
      let vm = this;
      if (this.params.publishMaterialIds.length > 0) {
        this.params.status = dat;
        if (dat == 1) {
          this.$confirm('确定已查看完毕，并对该单位核验材料批以"审核通过"处理吗？', "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              // this.$message.info({
              //   message: '若省局已经审核完成，请点击“上报国家新闻出版署”。',
              //   duration: 5000
              // });
              const loading = vm.$loading({
                lock: true,
                text: "处理中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
              });
              goProvinceExam(this.params).then((response) => {
                loading.close();

                // this.tabSeek('init');
                let tipCode = response.payload.tipCode;
                let tipMessage = response.payload.tipMessage;
                let resMsg = response.payload.resMsg;
                // console.log('response=',JSON.stringify(response));
                if (tipCode == "fail") {
                  this.$message({
                    message: tipMessage,
                    type: "error",
                  });
                } else {
                  this.$message({
                    message: "操作完成！",
                    type: "success",
                  });

                  this.tabSeek("init");
                }
              });
            })
            .catch(() => {
              loading.close();
            });
          // zym.退回
        } else if (dat == 3 || dat == 12 || dat == 13 || dat == 14) {
          this.backdiag = true;
          this.backtype = dat;
        }
      } else {
        this.$message.error("请勾选需要操作的出版社！");
      }
    },

    arrExam: function () {
      this.params.message = this.params.message.replace(/\s+/g, "");
      this.params.zanhuanMessage = this.params.zanhuanMessage.replace(/\s+/g, "");
      this.params.chexiaoMessage = this.params.chexiaoMessage.replace(/\s+/g, "");
      this.params.zhuxiaoMessage = this.params.zhuxiaoMessage.replace(/\s+/g, "");
      if (this.backtype == 3 && this.params.message.length == 0) {
        this.$message.error("请填写退回意见！");
      } else if (this.backtype == 12 && this.params.zanhuanMessage.length == 0) {
        this.$message.error("请填写暂缓意见！");
      } else if (this.backtype == 13 && this.params.zhuxiaoMessage.length == 0) {
        this.$message.error("请填写注销或拟注销意见！");
      } else if (this.backtype == 14 && this.params.chexiaoMessage.length == 0) {
        this.$message.error("请填写建议撤销意见！");
      } else {
        this.backdiag = false;
        let vm = this;
        const loading = vm.$loading({
          lock: true,
          text: "处理中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        goProvinceExam(this.params).then((response) => {
          loading.close();

          let tipCode = response.payload.tipCode;
          let tipMessage = response.payload.tipMessage;
          let resMsg = response.payload.resMsg;
          let appendMsg = resMsg ? resMsg.join(",") : "";
          console.log("response=", JSON.stringify(response));
          if (tipCode == "fail") {
            this.$message({
              message: tipMessage + " " + appendMsg,
              type: "error",
            });
          } else {
            this.$message({
              message: tipMessage + " " + appendMsg,
              type: "success",
            });
            this.tabSeek("init");
          }
        });
      }
    },

    handleClose: function () {
      this.params.message = "";
      this.backdiag = false;
    },

    checkDfine: function (row, inx) {
      if (
        row.status == 0 ||
        row.status == 1 ||
        // zym.新增
        row.status == 12 ||
        row.status == 21 ||
        row.status == 13 ||
        row.status == 14
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  created: function () {
    this.tabSeek();
    if (this.$route.query.key) {
      this.postDat.status = parseInt(this.$route.query.key);
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/provinceCom";

.province-7 {
  padding: 9px;

  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0px 20px;
    color: #666666;
    font-weight: bold;
  }
}

.tabArea {
  .tips {
    font-size: 14px;
    color: red;
    margin-left: 12px;
  }
}

.pg3_3dig {
  .tips {
    line-height: 30px;
    color: #666666;
  }

  .el-dialog__body {
    padding: 0px 20px;
  }

  textarea {
    resize: none;
  }
}
</style>



// WEBPACK FOOTER //
// successiveList.vue?6f21bc7a